import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function allClicksRequest(isLoading) {
  return {
    type: actionsTypesMembers.ALL_CLICKS_REQUEST,
    isLoading,
  }
}
function allClicksFailure(isError) {
  return {
    type: actionsTypesMembers.ALL_CLICKS_FAILURE,
    isError,
  }
}
function allClicksSuccess(isSuccess, allClicksData) {
  return {
    type: actionsTypesMembers.ALL_CLICKS_SUCCESS,
    isSuccess,
    allClicksData,
  }
}
export function fetchAllClicksAction(codeParrain) {
  return function(dispatch, getState) {

    dispatch(allClicksRequest(true))

    return backendMembers.getAllClicks(codeParrain)
      .then(allClicksData => {
        dispatch(allClicksRequest(false))
        dispatch(allClicksSuccess(true, allClicksData))
      })
      .catch(error => {
        dispatch(allClicksRequest(false))
        dispatch(allClicksFailure(true))
      })
  }
}

function allSouscriptionsRequest(isLoading) {
  return {
    type: actionsTypesMembers.ALL_SOUSCRIPTIONS_REQUEST,
    isLoading,
  }
}
function allSouscriptionsFailure(isError) {
  return {
    type: actionsTypesMembers.ALL_SOUSCRIPTIONS_FAILURE,
    isError,
  }
}
function allSouscriptionsSuccess(isSuccess, allSouscriptionsData) {
  return {
    type: actionsTypesMembers.ALL_SOUSCRIPTIONS_SUCCESS,
    isSuccess,
    allSouscriptionsData,
  }
}
export function fetchAllSouscriptionsAction(codeParrain) {
  return function(dispatch, getState) {

    dispatch(allSouscriptionsRequest(true))

    return backendMembers.getAllSouscriptions(codeParrain)
      .then(allSouscriptionsData => {
        dispatch(allSouscriptionsRequest(false))
        dispatch(allSouscriptionsSuccess(true, allSouscriptionsData))
      })
      .catch(error => {
        dispatch(allSouscriptionsRequest(false))
        dispatch(allSouscriptionsFailure(true))
      })
  }
}

function weekSouscriptionsRequest(isLoading) {
  return {
    type: actionsTypesMembers.WEEK_SOUSCRIPTIONS_REQUEST,
    isLoading,
  }
}
function weekSouscriptionsFailure(isError) {
  return {
    type: actionsTypesMembers.WEEK_SOUSCRIPTIONS_FAILURE,
    isError,
  }
}
function weekSouscriptionsSuccess(isSuccess, weekSouscriptionsData) {
  return {
    type: actionsTypesMembers.WEEK_SOUSCRIPTIONS_SUCCESS,
    isSuccess,
    weekSouscriptionsData,
  }
}
export function fetchWeekSouscriptionsAction(codeParrain) {
  return function(dispatch, getState) {

    dispatch(weekSouscriptionsRequest(true))

    return backendMembers.getWeekSouscriptions(codeParrain)
      .then(weekSouscriptionsData => {
        dispatch(weekSouscriptionsRequest(false))
        dispatch(weekSouscriptionsSuccess(true, weekSouscriptionsData))
      })
      .catch(error => {
        dispatch(weekSouscriptionsRequest(false))
        dispatch(weekSouscriptionsFailure(true))
      })
  }
}

function activatedPoliciesRequest(isLoading) {
  return {
    type: actionsTypesMembers.ACTIVATED_POLICIES_REQUEST,
    isLoading,
  }
}
function activatedPoliciesFailure(isError) {
  return {
    type: actionsTypesMembers.ACTIVATED_POLICIES_FAILURE,
    isError,
  }
}
function activatedPoliciesSuccess(isSuccess, activatedPoliciesData) {
  return {
    type: actionsTypesMembers.ACTIVATED_POLICIES_SUCCESS,
    isSuccess,
    activatedPoliciesData,
  }
}
export function fetchActivatedPoliciesAction(codeParrain) {
  return function(dispatch, getState) {

    dispatch(activatedPoliciesRequest(true))

    return backendMembers.getActivatedPolicies(codeParrain)
      .then(activatedPoliciesData => {
        dispatch(activatedPoliciesRequest(false))
        dispatch(activatedPoliciesSuccess(true, activatedPoliciesData))
      })
      .catch(error => {
        dispatch(activatedPoliciesRequest(false))
        dispatch(activatedPoliciesFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Parrain/index.js